module.exports = __webpack_public_path__ + "packs/media/images/junglebimbi-78bae5415ccf2591b3fdd25069826342.jpg";